import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decode',

    // WARN: Use with caution!
    // Use this if the pipe should be called on value changed.
    // pure: false,
})
export class DecodePipe implements PipeTransform {
    public transform(value: string): string {
        if (!value) {
            return value;
        }

        return decodeURIComponent(value);
    }
}
